import React from "react";
import { FaClock, FaPlaneDeparture, FaTools } from "react-icons/fa";

const UnderMaintenance = () => {
  return (
    <section className="relative isolate flex min-h-[72vh] items-center overflow-hidden bg-[#f6f9ff] px-4 py-16 sm:px-6 lg:px-8">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_20%_20%,rgba(40,113,211,0.14),transparent_34%),radial-gradient(circle_at_80%_10%,rgba(16,185,129,0.12),transparent_28%),linear-gradient(135deg,#ffffff_0%,#eef5ff_100%)]" />

      <div className="mx-auto grid w-full max-w-6xl items-center gap-10 lg:grid-cols-[1fr_0.85fr]">
        <div className="max-w-2xl">
          <div className="mb-6 inline-flex items-center gap-3 rounded-full border border-blue-100 bg-white px-4 py-2 text-sm font-semibold text-[#2871d3] shadow-sm">
            <FaTools className="text-base" aria-hidden="true" />
            Maintenance in progress
          </div>

          <h1 className="text-4xl font-extrabold leading-tight text-slate-950 sm:text-5xl lg:text-6xl">
            We are under maintenance
          </h1>

          <p className="mt-5 max-w-xl text-base leading-8 text-slate-600 sm:text-lg">
            CheapOFlyHub is getting a quick tune-up. We will be back shortly
            with a smoother travel booking experience.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="tel:+18000000000"
              className="inline-flex items-center justify-center rounded-md bg-[#2871d3] px-6 py-3 text-sm font-bold text-white shadow-lg shadow-blue-200 transition hover:bg-[#155bc2]"
            >
              Call support
            </a>
            <a
              href="mailto:support@cheapoflyhub.com"
              className="inline-flex items-center justify-center rounded-md border border-slate-200 bg-white px-6 py-3 text-sm font-bold text-slate-800 shadow-sm transition hover:border-[#2871d3] hover:text-[#2871d3]"
            >
              Email us
            </a>
          </div>
        </div>

        <div className="relative mx-auto aspect-square w-full max-w-md">
          <div className="absolute inset-0 rounded-full bg-white shadow-2xl shadow-blue-100" />
          <div className="absolute inset-8 rounded-full border border-blue-100 bg-[#f9fcff]" />
          <div className="absolute left-1/2 top-1/2 flex h-36 w-36 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-[#2871d3] text-white shadow-xl shadow-blue-200 sm:h-44 sm:w-44">
            <FaPlaneDeparture className="text-6xl sm:text-7xl" aria-hidden="true" />
          </div>
          <div className="absolute left-8 top-12 flex items-center gap-3 rounded-md bg-white px-4 py-3 shadow-lg">
            <FaClock className="text-[#2871d3]" aria-hidden="true" />
            <span className="text-sm font-bold text-slate-800">
              Back shortly
            </span>
          </div>
          <div className="absolute bottom-14 right-4 rounded-md bg-white px-4 py-3 text-sm font-semibold text-slate-600 shadow-lg sm:right-8">
            Thanks for your patience
          </div>
        </div>
      </div>
    </section>
  );
};

export default UnderMaintenance;
